import {useEffect} from 'react';

import {ProviderProps} from './providerProps';

export const MockCaptcha = ({onResult}: ProviderProps) => {
  useEffect(() => {
    onResult({provider: 'mock', token: 'mock-token'});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
